module.exports = __webpack_public_path__ + "static/email-template-receipt-bb5eb1df0834432b875c4aa0d9cd05ab.png";